import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qkzg5xrxcd: FaireBrandEntity = {
  token: "b_qkzg5xrxcd",
  type: "brand",
  name: "Cue",
  avatarUrl:
    "https://cdn.faire.com/fastly/1ce28d73c9160a74e5f9fe34390d0e7e1ed80d9e2cf843b3429947527695ed85.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9b36db2140122fcb8a6d1cd208a77b8f183931a67d5009ed22ed32fdde3288d3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1ce28d73c9160a74e5f9fe34390d0e7e1ed80d9e2cf843b3429947527695ed85.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9b36db2140122fcb8a6d1cd208a77b8f183931a67d5009ed22ed32fdde3288d3.jpeg",
  location: "Waynesboro, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 14,
  isTopShop: true,
  isInsider: true,
  description:
    "Cue candles couple elevated design with innovative technology. Every Cue candle includes our patented OpenWick™, which raises the standard on how a candle should burn to provide a truly clean and superior experience. Everything about the Cue brand is designed to be an attainable luxury for the everyday home, from our sleek candle jars to the high-quality fragrances we use.\n\nOpenWick™ Benefits:\n\nCleaner\n45% less soot accumulation on jars means jars and houses stay clean and attractive\n9x reduction in after-smoke/ember glow, allowing consumers to enjoy fragrances longer\n\nSafer\n33% shorter flame height creates a safer burn experience\n6x reduction in carbon build-up in jars, reducing risk of secondary ignition\n34% lower jar temperatures than traditional single-wick candles\n\nBetter\n31% faster wax pool means fragrance fills the room faster\nSelf-trimming curling wick means no trimming required (ditch the wick trimmers!)\n\n*Direct message to request samples*\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:22.554Z",
    importedBy: "entity-db-cli",
  },
};
